import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import EmployeeTabSA from './EmployeeTabSA';
import LeaveTabSA from './LeaveTabSA';
import TimeSheetSA from './TimeSheetSA';
import OthersSA from './OthersSA';
import WFHTabSA from './WFHTabSA';
import HrNotifications from './HrNotifications';
import QueriesHR from './QueriesHR';
import InternHr from './InternHr';
import LetterGeneration from './LetterGeneration';
import apiClient from '../ApiClient';

function HrPanel() {
    const location = useLocation();
    const [currentActiveTab, setCurrentActiveTab] = useState('1');
    const [queriesCount, setQueriesCount] = useState(0);
    const [letterData, setLetterData] = useState(null);

    const handleNavigateToLetter = (data) => {
        setLetterData(data);
        setCurrentActiveTab('10');
    };

    const toggle = tab => {
        if (currentActiveTab !== tab) {
            setCurrentActiveTab(tab);
        }
    }

    const checkQueries = async () => {
        try {
            const { data } = await apiClient.get(`${process.env.REACT_APP_BASE_URL}/user/tickets/kpis`, { headers: { skipLoader: true } })
            const activeCount = (data?.new || 0) + (data?.inProgress || 0) + (data?.waitingForEmployee || 0);
            setQueriesCount(activeCount);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (location.state?.activeTab === 'queries' || location.state?.tab === 'queries' || location.state?.tab === '8') {
            setCurrentActiveTab('8');
        }
    }, [location.state]);

    useEffect(() => {
        checkQueries();
    }, [])

    const TabButton = ({ id, label, badgeCount }) => (
        <button
            type="button"
            onClick={() => toggle(id)}
            className={`relative flex items-center px-5 py-3 text-sm font-medium whitespace-nowrap transition-all duration-200 border-b-2 ${
                currentActiveTab === id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
        >
            {label}
            {badgeCount > 0 && (
                <span className="ml-2 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-blue-500 px-1.5 text-[11px] font-semibold text-white shadow-sm">
                    {badgeCount}
                </span>
            )}
        </button>
    );

    return (
        <div id="main-scroll-container" className="bg-transparent w-full h-full flex flex-col overflow-y-auto overflow-x-hidden">
            <div className="max-w-[1700px] mx-auto px-2 sm:px-4 py-2 sm:py-2 flex-1 w-full flex flex-col">
                <div className="sticky top-0 z-20 bg-[#f6f6f6] pb-3 pt-2 -mt-2 -mx-2 sm:-mx-4 px-2 sm:px-4">
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                        <div className="flex overflow-x-auto scrollbar-hide">
                            <TabButton id="1" label="Employee" />
                            <TabButton id="2" label="Leave" />
                            <TabButton id="3" label="WFH" />
                            <TabButton id="4" label="TimeSheet" />
                            <TabButton id="5" label="Office Holidays" />
                            <TabButton id="7" label="Notifications" />
                            <TabButton id="8" label="HR Helpdesk" badgeCount={queriesCount} />
                            <TabButton id="9" label="Candidate" />
                            <TabButton id="10" label="Letter Generation" />
                        </div>
                    </div>
                </div>

                <div className="flex-1">
                    {currentActiveTab === '1' && <EmployeeTabSA />}
                    {currentActiveTab === '2' && <LeaveTabSA />}
                    {currentActiveTab === '3' && <WFHTabSA />}
                    {currentActiveTab === '4' && <TimeSheetSA />}
                    {currentActiveTab === '5' && <OthersSA />}
                    {currentActiveTab === '7' && <HrNotifications />}
                    {currentActiveTab === '8' && <QueriesHR checkQueries={checkQueries} />}
                    {currentActiveTab === '9' && <InternHr onNavigateToLetter={handleNavigateToLetter} />}
                    {currentActiveTab === '10' && <LetterGeneration letterData={letterData} clearLetterData={() => setLetterData(null)} />}
                </div>
            </div>
        </div>
    )
}

export default HrPanel